"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var BaseModal = /** @class */ (function (_super) {
    __extends(BaseModal, _super);
    function BaseModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseModal.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.props.onClose });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: this.props.modalClassName, isOpen: this.props.isOpen, toggle: this.props.onClose, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { className: this.props.modalHeaderClassName, close: closeBtn, children: this.props.modalHeader }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: this.props.modalBodyClassName, children: this.props.modalBody }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: this.props.modalFooterClassName, children: this.props.modalFooter })] }));
    };
    return BaseModal;
}(React.Component));
exports.BaseModal = BaseModal;
//# sourceMappingURL=BaseModal.js.map